// MobileSheet.jsx
//
// Універсальна шторка знизу для деталізації таблиць на мобільному (район →
// садочки, садочок → заявки). Той самий візуальний патерн, що й шторка
// фільтрів (MobileFilterDrawer у FiltersSection.jsx), тільки без футера з
// кнопками "Скасувати"/"Застосувати" — тут це просто контейнер, що віддає
// вкладеному рівню всю ширину екрана замість стиснутої комірки таблиці.
import React, { useEffect } from 'react';

const MobileSheet = ({ isOpen, onClose, title, subtitle, children }) => {
  useEffect(() => {
    if (isOpen) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = '';
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="publicstatistic-mobile-sheet-overlay" onClick={onClose}>
      <div className="publicstatistic-mobile-sheet-panel" onClick={e => e.stopPropagation()}>
        {/* Drag handle */}
        <div style={{ display: 'flex', justifyContent: 'center', padding: '10px 0 4px' }}>
          <div style={{ width: 40, height: 4, borderRadius: 2, background: '#d1d5db' }} />
        </div>
        <div className="publicstatistic-mobile-sheet-header">
          <div>
            {title && <h5>{title}</h5>}
            {subtitle && <div className="publicstatistic-mobile-sheet-subtitle">{subtitle}</div>}
          </div>
          <button className="publicstatistic-mobile-sheet-close" onClick={onClose}>✕</button>
        </div>
        <div className="publicstatistic-mobile-sheet-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default MobileSheet;
